var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("section", { staticClass: "section" }, [
    _c(
      "div",
      { staticClass: "container is-fluid" },
      [
        _c("b-loading", {
          attrs: { "is-full-page": false },
          model: {
            value: _vm.isLoading,
            callback: function ($$v) {
              _vm.isLoading = $$v
            },
            expression: "isLoading",
          },
        }),
        _c("h1", { staticClass: "title" }, [
          _vm._v(
            " " + _vm._s(_vm.$t("consignee.collections.collections")) + " "
          ),
        ]),
        _c(
          "b-table",
          { attrs: { data: _vm.data } },
          [
            _c("b-table-column", {
              attrs: {
                field: "COLLECT_DATE",
                label: _vm.$t("consignee.collections.estimated_pickup_date"),
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (props) {
                    return [_vm._v(" " + _vm._s(props.row.COLLECT_DATE) + " ")]
                  },
                },
              ]),
            }),
            _c("b-table-column", {
              attrs: {
                field: "COLLECT_ID",
                label: _vm.$t("consignee.collections.collect_id"),
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (props) {
                    return [_vm._v(" " + _vm._s(props.row.COLLECT_ID) + " ")]
                  },
                },
              ]),
            }),
            _c("b-table-column", {
              attrs: {
                field: "SHIPMENT_NR",
                label: _vm.$t("consignee.collections.shipment_reference"),
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (props) {
                    return [_vm._v(" " + _vm._s(props.row.SHIPMENT_NR) + " ")]
                  },
                },
              ]),
            }),
            _c("b-table-column", {
              attrs: {
                field: "FORWARDER_NAME",
                label: _vm.$t("consignee.collections.forwarder_name"),
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (props) {
                    return [
                      _vm._v(" " + _vm._s(props.row.FORWARDER_NAME) + " "),
                    ]
                  },
                },
              ]),
            }),
            _c("b-table-column", {
              attrs: {
                field: "MATNR",
                label: _vm.$t("consignee.collections.materials"),
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (props) {
                    return [_vm._v(" " + _vm._s(props.row.MATNR) + " ")]
                  },
                },
              ]),
            }),
            _c("b-table-column", {
              attrs: {
                field: "QTY",
                label: _vm.$t("consignee.collections.quantity"),
                numeric: "",
              },
              scopedSlots: _vm._u([
                {
                  key: "default",
                  fn: function (props) {
                    return [
                      _vm._v(
                        " " +
                          _vm._s(
                            props.row.QTY.slice(0, props.row.QTY.indexOf("."))
                          ) +
                          " "
                      ),
                    ]
                  },
                },
              ]),
            }),
          ],
          1
        ),
      ],
      1
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }